import { createHoppApp } from "@hoppscotch/common"

createHoppApp("#app")
